import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const Markdown = props => {
	return (
		<ReactMarkdown rehypePlugins={[rehypeRaw]} className={props.content.classes || "default-markdown"}>
			{props.content.body}
		</ReactMarkdown>
	);
};

Markdown.propTypes = {
	content: PropTypes.object
};

export default Markdown;
